import React from 'react'
export default function SkeletonTable({ rowCount, columnCount }) {
    const renderSkeletonRow = () => (
        <tr className="border-b border-gray-200 even:bg-gray-50 animate-pulse">
            {Array.from({ length: columnCount }, (_, index) => (
                <td key={index} className={`px-3 py-4 text-sm text-gray-700 ${index === 0 ? 'pl-8 pr-3' : '' }`} >
                    <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-full"></div>
                </td>
            ))}
        </tr>
    );
    return (
        <table className="table-auto w-full">
            <tbody className="text-sm divide-y divide-gray-100">
                {Array.from({ length: rowCount }, (_, index) => (
                    <React.Fragment key={index}>{renderSkeletonRow()}</React.Fragment>
                ))}
            </tbody>
        </table>
    );
}
